<template>
  <GPicture
    v-if="avatar"
    aria-hidden="true"
    alt="Avatar utilisateur"
    :path="avatar"
    type="avatar"
    :size="24"
    class="size-[24px] rounded-full"
  />
  <GSpinner v-else class="text-[24px] text-blue-500" />
</template>

<script setup>
const avatar = ref(null);
const { data: user } = await useFetchUser();

watch(
  user,
  (value) => {
    if (value?.avatar) {
      avatar.value = value.avatar;
    }
  },
  { immediate: true },
);
</script>
